import './Header.scss';

class Header {

	constructor(node) {
		this.node = node;
	}

	init() {
		const navbar = document.getElementById("navbar")
		/**
		 * Menu shrink
		 */
		window.onscroll = function () {
			if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
				navbar.classList.add('shrink');
			} else {
				navbar.classList.remove('shrink');
			}
		}

		window.onload = function () {
			const yOffset = window.pageYOffset;

			setSpacingToBody()

			if (yOffset > 80) {
				navbar.classList.add('shrink');
			}
		}

		const setSpacingToBody = () => {
			const heightNavbar = navbar.offsetHeight;
			document.body.style.paddingTop = `${heightNavbar}px`;
		}

		/**
		 * Disable Bg scrolling
		 */
		document.getElementById("navbar-toggler").addEventListener("click", function () {
			const html = document.querySelector('html');
			if (html.classList.contains('blocked')) {
				html.classList.remove('blocked');
			} else {
				html.classList.add('blocked');
			}
		});

		const linksMenu = document.querySelectorAll('.navbar-nav a[href^="#"]');
		linksMenu.forEach(function (item) {
			item.addEventListener("click", function () {
				if (window.innerWidth < 1200) {
					document.getElementById("navbar-toggler").click()
				}
			});
		});

		/**
		 * Hide menu after click
		 * to do
		 */
	}

}

JSModules['Header'] = Header;
export default Header;
